export const HomesIcon = ({ className = "h-6 w-6" }: { className?: string }) => {
  return (
    <img
      src="https://www.homes.com/assets/images/apple-touch-icon.png"
      alt="Homes.com"
      className={className}
    />
  );
};
